var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullBox"},[_c('div',{staticClass:"tableBox"},[_c('tableOne',{attrs:{"tableList":_vm.tableList},on:{"changeUpload":_vm.changeUpload}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }